import React, { useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import { format } from "date-fns";
import DataTable from "react-data-table-component";
import OrderEditStatusChanger from "./orderStatusChange";
import OrderInvoice from "./orderInvoice";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import swal from "sweetalert";

const FilterComponent = ({ filterText, onFilter, onClear }) => (
  <>
    <input
      id="search"
      type="search"
      placeholder="Search by ID, Name"
      aria-label="Search Input"
      defaultValue={filterText}
      onChange={onFilter}
      className="w-25 form-control float-left"
      autoComplete="off"
    />
  </>
);

const WorldofamorOrder = () => {
  const amormedusatoken = JSON.parse(localStorage.getItem("AMORtoken"));
  const [OrderData, setOrderData] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedOrderId, setSelectedOrderId] = useState(null);
  const [pending, setPending] = useState(true);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [cartData, setCartData] = useState();
  const [limit, setLimit] = useState(10); // Rows per page
  const filterProperties = ["email", "name", "id", "title", "phone", "city"];
  const resetComponent = () => {
    setStartDate(null);
    setEndDate(null);
    setFilterText("");
    setResetPaginationToggle(!resetPaginationToggle);
  };
  const DateFilterForm = ({ onDateChange }) => {
    const handleDateChange = () => {
      onDateChange(startDate, endDate);
    };
    const handleClear = () => {
      resetComponent();
    };

    return (
      <>
        <button
          type="button"
          className="btn bg-warning text-black ml-1"
          onClick={handleClear}
        >
          Reset Filter
        </button>
        {/* <button
          type="button"
          className="btn bg-black text-white ml-1"
          onClick={handleDateChange}
        >
          Apply
        </button> */}
        <DatePicker
          selected={endDate}
          onChange={(date) => setEndDate(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          placeholderText="End Date"
          className=" form-control"
        />

        <DatePicker
          selected={startDate}
          onChange={(date) => setStartDate(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          placeholderText="Start Date"
          className=" form-control"
        />
      </>
    );
  };

  const handleDateChange = (start, end) => {
    setStartDate(start);
    setEndDate(end);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setPending(false);
    }, 2000);
    return () => clearTimeout(timeout);
  }, []);

  const myHeaders = new Headers();
  myHeaders.append("Authorization", `Bearer ${amormedusatoken}`);

  var requestOptions = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await fetch(
        // `${
        //   process.env.REACT_APP_BASE_WorldofAmorURL
        // }admin/orders?limit=${limit}&offset=${(page - 1) * limit}`,
        `${
          process.env.REACT_APP_BASE_WorldofAmorURL
        }admin/orders?fields=*customer,*customer.addresses,*payment_collections&&limit=${limit}&offset=${(page - 1) * limit}&order=-display_id`,
        requestOptions,
      );

      const result = await response.json();

      setOrderData(result);

      if (result.orders?.length) {
        const requestOptions = {
          method: "GET",
          headers: {
            Authorization: `Bearer ${amormedusatoken}`,
          },
          redirect: "follow",
        };
      }
    } catch (error) {
      console.log("error", error);
      if (!error?.status || error?.status === "FETCH_ERROR") {
        navigate("/amorlogin");
        swal({
          title: "Session Expired Please Login Again",
          icon: "error",
          dangerMode: true,
        });
      } else if (error.status === 401) {
        navigate("/amorlogin");
        // swal({
        //   title: err.data.message,
        //   icon: "error",
        //   dangerMode: true,
        // });
      } else {
        swal({
          title: "Someting went wrong",
          icon: "error",
          dangerMode: true,
        });
      }
    }
  };

  useEffect(() => {
    fetchData(page, limit);
  }, [page, limit]);

  const filteredItems = OrderData?.orders?.filter((item) =>
    filterProperties.some(
      (property) =>
        new Date(item.created_at) > (startDate || new Date(0)) &&
        new Date(item.created_at) < (endDate || new Date()) &&
        // new Date(item.created_at) > new Date("2025-11-30T06:02:12.516Z") &&
        item[property] &&
        item[property].toLowerCase().includes(filterText.toLowerCase()),
    ),
  );

  // console.log(filteredItems + "filteredItems");
  // console.log("Note----------" + JSON.stringify(OrderData));
  const subHeaderComponentMemo = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
      setTotalRows(filteredItems.count);
    };
    return (
      <div className="SubFilterheader w-100 d-inline border p-3">
        <FilterComponent
          onFilter={(e) => setFilterText(e.target.value)}
          onClear={handleClear}
          filterText={filterText}
          className=""
        />
        <div className="dateSection d-flex flex-row-reverse w-75">
          <DateFilterForm onDateChange={handleDateChange} />
        </div>
      </div>
    );
  }, [filterText, resetPaginationToggle, startDate, endDate]);

  // Post Create Note
  // const [noteValue, setNoteValue] = useState("");
  // const [rowNoteValues, setRowNoteValues] = useState({});
  // const [rowNotes, setRowNotes] = useState({});

  // const setRowNoteValue = (orderId, value) => {
  //   setRowNoteValues((prevRowNoteValues) => ({
  //     ...prevRowNoteValues,
  //     [orderId]: value,
  //   }));
  // };

  // const createNote = async (orderId) => {
  //   const raw = JSON.stringify({
  //     resource_id: `${orderId}`,
  //     resource_type: "order",
  //     value: rowNoteValues[orderId],
  //   });

  //   const myHeaders = new Headers();
  //   myHeaders.append("Authorization", `Bearer ${amormedusatoken}`);
  //   myHeaders.append("Content-Type", "application/json");

  //   var requestOptionsNote = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_amordovale_URL}admin/notes`,
  //       requestOptionsNote
  //     );
  //     const result = await response.json();
  //     // setRowNotes((prevRowNotes) => ({
  //     //   ...prevRowNotes,
  //     //   [orderId]: result,
  //     // }));
  //   } catch (error) {
  //     console.log("error", error);
  //     // Handle error here
  //   }
  // };

  // Get Create Note Response

  // const getNotes = async () => {
  //   const requestOptionsRowNote = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_amordovale_URL}admin/notes?limit=100000000`,
  //       requestOptionsRowNote
  //     );
  //     const result = await response.json();

  //     setRowNotes(result);
  //   } catch (error) {
  //     console.log("error", error);
  //     // Handle error here
  //   }
  // };

  // useEffect(() => {
  //   if (amormedusatoken) {
  //     getNotes();
  //   }
  // }, [amormedusatoken]);

  // Get Product fulfilment Status
  // const [NSFulStatus, setNSFulStatus] = useState({});
  // const getNsFullfilment = async () => {
  //   const requestOptionsRowNsFullfilment = {
  //     method: "GET",
  //     headers: myHeaders,
  //     redirect: "follow",
  //   };

  //   try {
  //     const response = await fetch(
  //       `${process.env.REACT_APP_BASE_amordovale_URL}admin/orders?fields=order_status`,
  //       requestOptionsRowNsFullfilment
  //     );
  //     const result = await response.json();

  //     setNSFulStatus(result);
  //   } catch (error) {
  //     console.log("error", error);
  //     // Handle error here
  //   }
  // };

  // useEffect(() => {
  //   getNsFullfilment();
  // }, []);

  // Data Table Order Section
  const columns = [
    {
      name: "Date",
      selector: (row) => format(new Date(row.created_at), "MM/dd/yyyy"),
      sortable: true,
    },
    {
      name: "Order ID",
      selector: (row) => row.id,
      sortable: true,
      grow: 2,
      wrap: true,
    },

    {
      name: "Name",
      grow: 2,
      selector: (row) =>
        row.customer !== null && row.customer !== undefined
          ? row.customer?.addresses[0]?.first_name +
            " " +
            row.customer?.addresses[0]?.last_name
          : "no data",
      sortable: false,
      wrap: true,
    },

    {
      name: "Phone",
      selector: (row) => row.customer?.addresses[0]?.phone,
    },
    {
      name: "Promoter Name",
      selector: (row) => row.customer?.addresses[0]?.metadata?.promoterName,
    },
    // {
    //   name: "Voucher Code",
    //   selector: (row) => row.customer?.addresses[0]?.metadata?.promoterName,
    // },
    {
      name: "Address",
      grow: 3,
      wrap: true,
      selector: (row) =>
        row.customer !== null && row.customer !== undefined
          ? row.customer?.addresses[0]?.address_1 +
            " , " +
            row.customer?.addresses[0]?.city +
            "  , " +
            row.customer?.addresses[0]?.postal_code
          : "",
    },
    // {
    //   name: "City",
    //   selector: (row) => row.customer !== null && row.customer !== undefined  ?( row.customer?.addresses[0]?.city ) : null,
    //   wrap: true,
    //   grow: 2,
    // },

    {
      name: "Product Name",
      grow: 3,
      wrap: true,
      selector: (row) =>
        row.items
          .map(
            (name) =>
              name.quantity +
              " x " +
              name.product_title +
              " - " +
              name?.variant_title,
            // name?.variant?.metadata?.item_weight
          )
          .join(" , "),
    },

    {
      name: "Price",
      selector: (row) => `₹${parseFloat(row?.payment_collections[0]?.amount)}`,
    },
    {
      name: "Payment Status",
      selector: (row) => (
        <b className="text-success">
          {
            // (row.payments[0].provider_id = "system"
            //   ? "Paid"
            //   :
            row?.payment_collections[0]?.status
            // )
          }
        </b>
      ),
    },
    {
      name: "Fulfillment Status",
      selector: (row) =>
        row?.metadata?.custom_status !== undefined ? (
          row?.metadata?.custom_status
        ) : (
          <b className="text-warning">New Order</b>
        ),
    },
    {
      name: "Order Shippment Status",
      grow: 3,
      selector: (row) =>
        row?.payment_collections[0]?.status !== "awaiting" &&
        row?.payment_collections[0]?.status !== "requires_action" &&
        row?.metadata?.custom_status !== "Delivered" ? (
          <>
            <OrderEditStatusChanger
              amormedusatoken={amormedusatoken}
              orderId={row?.id}
              orderStatus={row?.metadata?.custom_status}
              customerPhone={row.customer?.addresses[0]?.phone}
            />
          </>
        ) : (
          <button
            className="btn text-wrap "
            disabled
            style={{ fontSize: "12px" }}
          >
            {row?.metadata?.custom_status !== "Delivered"
              ? "Payment Awating"
              : " Order Delivered"}
          </button>
        ),
    },
    {
      name: "Invoice",
      grow: 3,
      selector: (row) => (
        <OrderInvoice
          amormedusatoken={amormedusatoken}
          orderId={row.id}
        />
      ),
    },
  ];

  const downloadReport = () => {
    const csvContent = prepareCSVData(filteredItems);
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");

    if (navigator.msSaveBlob) {
      navigator.msSaveBlob(blob, "order_report.csv");
    } else {
      link.href = URL.createObjectURL(blob);
      link.download = "order_report.csv";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  };
  const prepareCSVData = (data) => {
    const headers = [
      "Date",
      "Order ID",
      "Name",
      "Phone",
      "promoter",

      "Price",
      "Payment Status",
      "Order Fulfillment Status",
      "Address",
      "Pincode",
      "City",
      "Product Name",
      "Product Weight",
      "Product Qty",
    ];

    const csvRows = [];
    csvRows.push(headers.join(","));

    data.forEach((order) => {
      const commonDetails = [
        format(new Date(order.created_at), "MM/dd/yyyy HH:mm:ss"),
        order.id,
        order.customer !== null && order.customer !== undefined
          ? order.customer?.addresses[0]?.first_name +
            " " +
            order.customer?.addresses[0]?.last_name
          : "no data",
        order.customer?.addresses[0]?.phone,
        order.customer?.addresses[0]?.metadata?.promoterName,

        `₹${parseFloat(order?.payment_collections[0]?.amount)}`,
        order?.payment_collections[0]?.status || "Unknown",
        order?.metadata?.custom_status !== undefined
          ? order?.metadata?.custom_status
          : "",
        order.customer !== null && order.customer !== undefined
          ? order.customer?.addresses[0]?.address_1
          : "",

        order.customer?.addresses[0]?.postal_code,
        order.customer?.addresses[0]?.city,
      ];

      order.items.forEach((item, index) => {
        const productDetails = [item.product_title, item.quantity];

        const columns =
          index === 0
            ? [...commonDetails, ...productDetails]
            : [...new Array(commonDetails.length).fill(""), ...productDetails];

        csvRows.push(columns.join(","));
      });
    });

    return csvRows.join("\n");
  };

  // Example usage
  const data = [
    // Your orders data here
  ];

  // console.log(prepareCSVData(data));

  const paginationOptions = {
    rowsPerPageText: "Rows per page:",
    rangeSeparatorText: "of",
    noRowsPerPage: false,
    selectAllRowsItem: true,
    selectAllRowsItemText: "All",
  };

  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleRowsPerPageChange = (newLimit) => {
    setLimit(newLimit);
    setPage(1); // Reset to first page when changing rows per page
  };
  return (
    <div className="container-fluid">
      <div className="d-sm-flex align-items-center justify-content-between mb-4">
        <h1 className="h3 mb-0 text-gray-800">Order Data</h1>
        <button
          className="btn btn-sm btn-primary shadow-sm"
          onClick={downloadReport}
        >
          <i className="fas fa-download fa-sm text-white-50"></i> Download
          Report
        </button>
      </div>
      <div className="row">
        <div className="col-md-12">
          <DataTable
            className="TableNs"
            columns={columns}
            data={filteredItems}
            progressPending={pending}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            paginationPerPage={limit}
            onChangeRowsPerPage={handleRowsPerPageChange}
            onChangePage={handlePageChange}
            subHeader
            subHeaderComponent={subHeaderComponentMemo}
            paginationRowsPerPageOptions={[10, 50, 150, 250, 350]}
            paginationComponentOptions={paginationOptions}
            highlightOnHover
          />
        </div>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>View Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedOrderId && (
            <OrderEditStatusChanger
              amormedusatoken={amormedusatoken}
              orderId={selectedOrderId}
              onClose={() => setShowModal(false)}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default WorldofamorOrder;
